import type { ServiceResponse } from "~/api/axios.ts";
import { api, getAuthHeaders } from "~/api/axios.ts";
import { addSortAndFilterParams } from "~/utils";
import type { Patient } from "./patients";
import type { PaginationParams, SearchParams, SortingParams } from "./types";

export interface Unit {
  id: number;
  name: string;
  location: string;
  patients_count?: number;
}

export const getUnit = async (id: number) => {
  const response = await api.get<ServiceResponse<Unit>>(`/units/${id}`, {
    headers: getAuthHeaders(),
  });

  return response.data;
};

export const getUnits = async (params: PaginationParams) => {
  const response = await api.get<ServiceResponse<Unit[]>>("/units", {
    headers: getAuthHeaders(),
    params,
  });

  return response.data;
};

export const getUnitPatients = async (
  unitId: number,
  {
    page,
    per_page,
    search,
    order_by,
    sort_direction,
  }: PaginationParams & SortingParams & SearchParams,
) => {
  const params: Record<string, string | number> = {
    page,
    per_page,
  };

  const fullParams = addSortAndFilterParams(
    search,
    order_by,
    sort_direction,
    params,
  );

  const response = await api.get<ServiceResponse<Patient[]>>(
    `/units/${unitId}/patients`,
    {
      headers: getAuthHeaders(),
      params: fullParams,
    },
  );

  return response.data;
};
